import { BenchmarkIcon } from "@/assets/images/svgIcons/benchmarkIcon"
import { Separator } from "@/components/ui/baseUi/separator"
import { BenchmarkExercise } from "@modules/benchmark/components/benchmarkExercise"
import { useBenchmark } from "@modules/benchmark/hooks/useBenchmark"
import { word } from "@modules/core/utils/i18n"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { Text } from "@/components/ui/baseUi/text"

type BenchmarkInfoResumeProps = {
  benchmarkId: string
}

export const BenchmarkInfoResume: React.FC<BenchmarkInfoResumeProps> = ({ benchmarkId }) => {
  const { data: benchmark } = useBenchmark(benchmarkId)

  return (
    <>
      {benchmark ? (
        <div className="mt-2 flex grow flex-col p-6">
          <div className="flex w-fit items-center gap-1 rounded-full bg-neutral-900/70 px-3 py-2">
            <BenchmarkIcon color={"white"} className="mr-2" />
            <Text fontStyle="LM" className="text-textOnColor-body">
              {word("global.benchmark.name")}
            </Text>
          </div>

          <div className="mt-8.5 flex flex-col">
            <Text fontStyle="HM" className="mb-2">
              {benchmark.title}
            </Text>
            <Text fontStyle="BM" className="text-neutral-700">
              {benchmark.category}
            </Text>
          </div>

          <Separator className="my-8" />
          <Text fontStyle="LS" className="text-neutral-700">{`(1) ${word(
            "program.planning.create.exercise.block",
          ).toUpperCase()} `}</Text>
          <BenchmarkExercise benchmark={benchmark} />
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  )
}
